module.exports = __webpack_public_path__ + "media/newstyle/images/icon-camera-8e916217d987ac4acd868de0659e3fbb.svg";